import React from 'react';

const TermsPage = () => {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <div className="bg-white rounded-lg shadow-lg p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-8 text-center">服务条款与条件</h1>
        
        <div className="prose prose-lg max-w-none">
          <div className="mb-8">
            <p className="text-gray-600 mb-6">
              欢迎访问南昌市玉洒贸易有限公司网站。本条款与条件（以下简称"条款"）适用于您对本网站的访问和使用。
              通过访问或使用本网站，您同意受本条款的约束。
            </p>
          </div>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. 公司信息</h2>
            <div className="bg-gray-50 p-4 rounded-lg">
              <p><strong>公司名称：</strong>南昌市玉洒贸易有限公司</p>
              <p><strong>经营地址：</strong>江西省南昌市西湖区</p>
              <p><strong>联系电话：</strong>+86 13907917041</p>
              <p><strong>电子邮箱：</strong>info@ystrades.com</p>
              <p><strong>经营范围：</strong>五粮液等酒类产品的销售（凭有效许可证经营）</p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. 商品特殊说明</h2>
            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4">
              <p className="font-medium text-yellow-800 mb-2">重要提示：</p>
              <ul className="list-disc list-inside text-yellow-700 space-y-1">
                <li>本公司销售的酒类产品属于特殊商品</li>
                <li>根据《食品安全法》等相关法律法规，酒类商品具有特殊属性</li>
                <li>所有产品均为正品，来源可追溯，质量有保障</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. 购买与支付</h2>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li>所有价格均以人民币计价，可能会根据市场情况进行调整</li>
              <li>订单确认后，请在规定时间内完成支付</li>
              <li>支付成功后，订单即生效，不可随意取消</li>
              <li>我们接受多种支付方式，具体以网站显示为准</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. 退换货政策</h2>
            <div className="bg-red-50 border-l-4 border-red-400 p-4 mb-4">
              <p className="font-medium text-red-800 mb-2">特别声明：</p>
              <p className="text-red-700">
                鉴于酒类商品的特殊属性，根据相关法律法规，酒类商品不适用七天无理由退货政策。
              </p>
            </div>
            

            <h3 className="text-xl font-medium text-gray-800 mb-3">4.2 退换流程</h3>
            <ol className="list-decimal list-inside space-y-2 text-gray-700 mb-4">
              <li>经多方确认，且在本公司同意下，按照公司指导进行退换货操作</li>
            </ol>

            <h3 className="text-xl font-medium text-gray-800 mb-3">4.3 不可退换情形</h3>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li>因个人原因（如口感偏好、购买数量过多等）要求退货</li>
              <li>商品包装已开启或商品已被消费</li>
              <li>超过规定时间未及时联系客服</li>
              <li>无法提供有效购买凭证</li>
              <li>人为损坏或保存不当造成的商品问题</li>
            </ul>

            <div className="bg-gray-100 p-4 rounded-lg mt-4">
              <p className="font-medium text-gray-800">
                最终解释权：所有退换货事宜的最终解释权归南昌市玉洒贸易有限公司所有。
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. 配送服务</h2>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li>我们提供专业的酒类配送服务</li>
              <li>配送范围和时间以网站公布为准</li>
              <li>签收时请当面验货，如发现问题请拒收并及时联系客服</li>
              <li>特殊天气或不可抗力因素可能影响配送时间</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. 法律责任</h2>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li>请确保您已达到法定饮酒年龄（18周岁以上）</li>
              <li>购买者需为完全民事行为能力人</li>
              <li>禁止向未成年人销售酒类产品</li>
              <li>请理性饮酒，饮酒请勿驾车</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. 知识产权</h2>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li>本网站所有内容受知识产权法保护</li>
              <li>五粮液相关商标、标识归其权利人所有</li>
              <li>未经授权，禁止复制、传播本网站内容</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. 争议解决</h2>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li>本条款的签订、履行和解释适用中华人民共和国法律</li>
              <li>如发生争议，双方应协商解决</li>
              <li>协商不成的，提交公司所在地人民法院管辖</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. 条款修改</h2>
            <p className="text-gray-700">
              本公司有权根据业务发展需要修改本条款，修改后的条款将在网站上公布。
              继续使用本网站即视为同意修改后的条款。
            </p>
          </section>

          <div className="bg-blue-50 border-l-4 border-blue-400 p-4 mt-8">
            <p className="text-blue-800">
              <strong>客服联系方式：</strong><br/>
              电话：+86 13907917041<br/>
              邮箱：info@ystrades.com<br/>
            </p>
          </div>

          <div className="text-center mt-8 pt-8 border-t border-gray-200">
            <p className="text-gray-500">
              本条款最后更新时间：{new Date().getFullYear()}年{new Date().getMonth() + 1}月{new Date().getDate()}日
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;